The name of a person associated with an object.
